<template>
  <h4
    class="font-weight-bold mt-0 mb-6 blue-grey--text text--darken-3"
    v-html="sanitizedTitle"
    data-testid="widget-title"
  ></h4>
</template>

<script>
export default {
  name: 'Title',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    sanitizedTitle() {
      return this.$sanitize(this.title)
    },
  },
}
</script>
